import React from 'react';

const SearchValidationPopup = ({ showPopup, onClose }) => {
  if (!showPopup) return null;

  return (
    <div 
      className="search-validation-overlay" 
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="search-validation-content">
        <p className="search-validation-message">Please Enter 3+ Search Terms For Best Results</p>
        <button 
          className="search-validation-ok-btn" 
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default SearchValidationPopup;
